export default {
  // message for logout fail
  LOGOUT_ERROR: 'Logout Error',
};
